<div class="breadcrumb bg-neutral-25 mb-0">
  <div class="container text-opacity-5">
    <a [routerLink]="['/invoices']">Back to invoice list</a>
  </div>
</div>


<!-- <div class="content-container"> -->
<div class="container page-auction-search" *ngIf="InvoiceDetail.Invoice">
  <h5>Invoice details</h5>

  <div class="row mt-3">
    <div class="col-12">
      <div class="card card-body">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="InvoiceNo">Invoice No</label>
              <div>{{InvoiceNumber}}</div>
            </div>
          </div>

          <div class="col">
            <div class="form-group">
              <label for="InvoiceNo">Auction</label>
              <div>{{InvoiceDetail.Invoice?.Auction?.Title}}</div>
            </div>
          </div>

          <div class="col">
            <div class="form-group">
              <label for="InvoiceNo">Auction</label>
              <div>{{InvoiceDetail.Invoice?.Customer?.AccountNumber}}</div>
            </div>
          </div>

          <div class="col">
            <div class="form-group">
              <label for="InvoiceNo">Invoice Date</label>
              <div>{{InvoiceDetail.Invoice.DateCreated|date:'dd/MM/yyyy'}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div class="row mt-3">
    <div class="col-10">
      <h5>Invoice totals</h5>
    </div>
    <div class="col-2 text-right">
      <button class="btn btn-sm btn-primary btn-red" (click)="PayNow()" *ngIf="GetBalanceNumber()>0">Pay now</button>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-12">
      <div class="card card-body">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>Invoice total</label>
              <div>{{GetTotals('invoice')}}</div>
            </div>
          </div>

          <div class="col">
            <div class="form-group">
              <label>Premium included</label>
              <div>{{GetTotals('premium')}}</div>
            </div>
          </div>

          <div class="col">
            <div class="form-group">
              <label>Adjustments included</label>
              <div>{{GetTotals('adjustment')}}</div>
            </div>
          </div>

          <div class="col">
            <div class="form-group">
              <label>GST in total</label>
              <div>{{GetTotals('gstincluded')}}</div>
            </div>
          </div>

          <div class="col">
            <div class="form-group">
              <label>Payments</label>
              <div>{{GetTotals('payments')}}</div>
            </div>
          </div>

          <div class="col">
            <div class="form-group">
              <label>Balance</label>
              <div>{{GetTotals('balance')}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>


  <h5 class="mt-3">Purchases</h5>
  <div class="row">
    <div class="col-12">
      <div class="card card-body">
        <table class="table" style="border-top:0px none;">
          <thead>
            <tr style="border-top:0px none;">
              <th style="border-top:0px none;">Lot #</th>
              <th style="border-top:0px none;">Description</th>
              <th style="border-top:0px none;">Qty</th>
              <th style="border-top:0px none;">Hammer Price ea</th>
              <th style="border-top:0px none;">Total Hammer Incl GST</th>
              <th style="border-top:0px none;">GST in Total Hammer</th>
              <th style="border-top:0px none;">Lot Premium</th>
              <th style="border-top:0px none;">Premium inc GST</th>
              <th style="border-top:0px none;">GST in Premium</th>
              <th style="border-top:0px none;">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of InvoiceDetail.InvoiceItems">
              <td>{{item.LotNumber}}</td>
              <td>{{item.Description}}</td>
              <td>{{item.Quantity}}</td>
              <td>{{item.HammerPrice|number:'1.2-2'}}</td>
              <td>{{item.TotalHammerInclGST|number:'1.2-2'}}</td>
              <td>{{item.GSTTotalHammer|number:'1.2-2'}}</td>
              <td>{{item.LotPremium|number:'1.2-2'}}</td>
              <td>{{item.PremiumIncGST|number:'1.2-2'}}</td>
              <td>{{item.GSTPremium|number:'1.2-2'}}</td>
              <td>{{(item.PremiumIncGST+item.TotalHammerInclGST)|number:'1.2-2'}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <h5 class="mt-3">Other charges</h5>
  <div class="row">
    <div class="col-12">
      <div class="card card-body">
        <table class="table" style="border-top:0px none;">
          <thead>
            <tr style="border-top:0px none;">
              <th style="border-top:0px none;">Date</th>
              <th style="border-top:0px none;">Description</th>
              <th style="border-top:0px none;" class="text-right">Amount</th>
              <th style="border-top:0px none;" class="text-right">GST</th>
              <th style="border-top:0px none;" class="text-right">Total inc GST</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="!InvoiceDetail.InvoiceAdjustments.length">
              <td colspan="5">
                <span>No adjustments to display</span>
              </td>
            </tr>
            <tr *ngFor="let item of InvoiceDetail.InvoiceAdjustments">
              <td>{{item.DateCreated|date:'dd/MM/yyyy'}}</td>
              <td>{{item.Description}}</td>
              <td class="text-right">${{item.Amount|number:'1.2-2'}}</td>
              <td class="text-right">${{item.Gst|number:'1.2-2'}}</td>
              <td class="text-right">${{(item.Amount+item.Gst)|number:'1.2-2'}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <h5 class="mt-3">Payments</h5>
  <div class="row">
    <div class="col-12">
      <div class="card card-body">
        <table class="table" style="border-top:0px none;">
          <thead>
            <tr style="border-top:0px none;">
              <th style="border-top:0px none;">Date</th>
              <th style="border-top:0px none;">Payment Method</th>
              <th style="border-top:0px none;">Notes</th>
              <th style="border-top:0px none;" class="text-right">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="!InvoiceDetail.InvoicePayments.length">
              <td colspan="5">
                <span>No payments to display</span>
              </td>
            </tr>
            <tr *ngFor="let item of InvoiceDetail.InvoicePayments">
              <td>{{item.DateCreated|date:'dd/MM/yyyy'}}</td>
              <td>{{item.Method}}</td>
              <td>{{item.Notes}}</td>
              <td class="text-right">${{item.Amount|number:'1.2-2'}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>




</div>
<!-- </div> -->
